import { type TFunction } from 'i18next';

import type { AlertGroup, AlertMessage } from './types';

/**
 * 사용자 관점 AlertGroup별 알럿 메시지 (DOC §9 기준).
 *
 * 메시지는 preview/generate 단계 무관하게 동일 — AlertGroup 자체가 단계 차이를
 * 흡수하기 때문이다. (e.g. `http_error`/`timeout`은 단계별로 다른 group으로
 * 분기해 들어와 메시지가 자연스럽게 갈린다.)
 */
export const getWebsiteAlertMessages = (
  t: TFunction<'build'>,
): Record<AlertGroup, AlertMessage> => ({
  invalidUrl: {
    title: t('build.website.alert.invalidUrl.title'),
  },
  unusableUrl: {
    title: t('build.website.alert.unusableUrl.title'),
    body: t('build.website.alert.unusableUrl.body'),
  },
  fileUrl: {
    title: t('build.website.alert.fileUrl.title'),
    body: t('build.website.alert.fileUrl.body'),
  },
  loginRequiredWebsite: {
    title: t('build.website.alert.loginRequired.title'),
    body: t('build.website.alert.loginRequired.body'),
  },
  websiteNotFound: {
    title: t('build.website.alert.notFound.title'),
    body: t('build.website.alert.notFound.body'),
  },
  websiteInfoUnavailable: {
    title: t('build.website.alert.fetchFailed.title'),
    body: t('build.actionError.waitTry'),
  },
  unusableWebsite: {
    title: t('build.website.alert.forbidden.title'),
  },
  contentTooShort: {
    title: t('build.website.alert.contentTooShort.title'),
    body: t('build.website.alert.contentTooShort.body'),
  },
  contentTooLarge: {
    title: t('build.website.alert.contentTooLong.title'),
    body: t('build.website.alert.contentTooLong.body'),
  },
  generateFailed: {
    title: t('build.website.alert.genericError.title'),
    body: t('build.website.alert.genericError.body'),
  },
});
